import { Component } from '@angular/core'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { viewProductPromocodeModel } from '../../models/product-promo-code.model'
import { ActivatedRoute } from '@angular/router'
import { SharedService } from 'src/app/shared/services/shared.service'
import { gender } from '../../models/products.enum'
import { TranslateService } from '@ngx-translate/core'
import { ProductsService } from '../../services/products.service'
import { Router } from '@angular/router'
import { MatSlideToggleChange } from '@angular/material/slide-toggle'
import { environment } from 'src/environments/environment'
environment

@Component({
	selector: 'app-view-product-promocode',
	templateUrl: './view-product-promocode.component.html',
	styleUrl: './view-product-promocode.component.scss',
})
export class ViewProductPromocodeComponent {
	id: string = ''
	isActiveEnum = ActivationStatus
	promocodeDetials!: viewProductPromocodeModel
	genders!: any
	editMode: boolean = false
	attachmentLink = environment.attachmentPath
	constructor(
		private route: ActivatedRoute,
		private SharedService: SharedService,
		public translate: TranslateService,
		private ProductsService: ProductsService,
		private router: Router
	) {
		this.SharedService.handleBreadCrumb('add-product-promo-code', true, {
			name: '',
			id: null,
			url: '',
			queryParams: null,
		})
		this.SharedService.headerTitle.next('BREADCRUMB.VIEW-PROMO-CODE')
	}
	ngOnInit() {
		this.genders = this.SharedService.returnEnumArray(gender)
		this.id = this.route.snapshot.paramMap.get('id') as string
		this.getPromocodeDetails()
	}
	getPromocodeDetails() {
		this.ProductsService.getPromocodeDetails(this.id).subscribe(
			(res: any) => (this.promocodeDetials = res.result)
		)
	}
	deletePromocode() {
		this.ProductsService.deletePromocode(this.id).subscribe({
			complete: () => {
				this.router.navigate(['/layout/store/products/product-promocode-list'])
			},
		})
	}
	changeEditMode(editMode: boolean) {
		this.editMode = editMode
		editMode
			? this.SharedService.headerTitle.next('PRODUCT_PROMO.EDIT_PROMO_CODE')
			: this.SharedService.headerTitle.next('BREADCRUMB.VIEW-PROMO-CODE')
	}
	activateDeactivatePromocode(event: MatSlideToggleChange) {
		this.ProductsService.activateDeactivatePromocodde(
			this.id,
			event.checked
		).subscribe((res) => this.getPromocodeDetails())
	}
}
